module.exports = __webpack_public_path__ + "media/images/instagram-05e5d9867e7abe9ccc0d334e8f3dbf17.svg";